import React from 'react';
// import ReactHighStock from 'react-highcharts/ReactHighstock.src';
import ReactHighCharts from 'react-highcharts/ReactHighcharts.src'


const PortfolioChart = ({sections,sectionsData}) => {

	const config =  {
		chart: {
			type: 'bar',
		},
		title: {
			// enabled: false,
			text: '',
		},
		credits: {
			enabled: false
		},
		navigator: {
			enabled: false,
		},
		scrollbar: {
			enabled: false
		},
		rangeSelector: {
			enabled: false
		},
		legend: { enabled: false },
		xAxis: {
			categories: sections,

		},
		yAxis: {
			min: 0,
			title: {
				text: '',
				align: 'high',
			},
			labels: {
				overflow: 'justify',
			},
		},
		series: [
			{
				name: 'Value',
				data: sectionsData,
				dataLabels: {
					enabled: true,
					formatter: function () {
						const total = this.series.data.reduce((acc, point) => acc + point.y, 0); // Get total sum
						const percentage = ((this.y / total) * 100).toFixed(2); // Calculate percentage
						return `${percentage}%`; // Return the percentage value
					},
					align: 'left',
					inside: false,
				},
			},
		],
		plotOptions: {
			series: {
				dataLabels: {
					enabled: true,
				},
			},
		},
	};


	return (
		<ReactHighCharts config={config} />
	);
}

export default PortfolioChart;